import CommonService from './common';
import { WEB_SSO, SSO_AFF_URL } from '../../../utils/urls';
import { encryptParams } from '../../../utils/index';
import { TypeRequest } from '../../../types';

export default class LoginService extends CommonService {
  private host: string | undefined;
  private originHost: string | undefined;
  private aid: number;
  constructor(props: {
    aid: number;
    request: TypeRequest;
    host?: string | undefined;
    originHost: string;
  }) {
    super(props);
    let { host, originHost, aid } = props;
    this.aid = aid;
    this.host = host;
    this.originHost = originHost;
  }

  /**
   * [check login status]
   * @param {string} service redirect url after login success
   * @return {Promise} login result
   */
  public checkLogin = (params: {
    service: string;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.request({
      url: WEB_SSO.CHECK_LOGIN,
      method: 'GET',
      data: {
        ...rest,
        ...extra_params,
      },
    });
  };

  // /**
  //  * [get mobile verification code] out-of-date
  //  * @param {string} mobile the mobile used to login
  //  * @return {Promise} send result
  //  */
  // public sendMobileCode(params: { mobile: string }): Promise<any> {
  //   return this.baseSendMobileCode({
  //     ...params,
  //     type: 24,
  //   });
  // }

  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  public sendMobileCodeV2 = (params: {
    mobile: string;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendMobileCodeV2({
      ...rest,
      type: 24,
      ...extra_params,
    });
  };

  // /**
  //  * [quick authentication] out-of-date
  //  * @param {string} mobile the mobile used to login
  //  * @param {number} service redirect url after login success
  //  * @return {Promise} send result
  //  */
  // public quickAuth(params: { service: string; mobile: string }): Promise<any> {
  //   let { mobile, ...extra_params } = params;
  //   const data = encryptParams({ mobile, ...extra_params }, ['mobile']);
  //   return new Promise((resolve, reject) => {
  //     this.request({
  //       url: WEB_SSO.MOBILE_CODE_LOGIN_URL,
  //       method: 'POST',
  //       data,
  //     })
  //       .then((data: any) => {
  //         resolve(data);
  //       })
  //       .catch((e: any) => {
  //         reject(e);
  //       });
  //   });
  // }

  /**
   * [quick authentication V2]sso 登录+注册
   * @param {string} mobile the mobile used to login
   * @param {string} code corresponding code
   * @param {number} service redirect url after login success
   * @return {Promise} send result
   */
  public quickAuthV2 = (params: {
    service: string;
    mobile: string;
    code: string;
    extra_params?: object;
  }) => {
    let { mobile, code, service, extra_params = {} } = params;
    const data = encryptParams({ mobile, code, service, ...extra_params }, [
      'mobile',
      'code',
      'password',
    ]);
    return this.request({
      url: WEB_SSO.MOBILE_CODE_LOGIN_URL_V2,
      method: 'POST',
      data,
    });
  };

  /**
   * [quick authentication V2]sso 仅登录
   * @param {string} mobile the mobile used to login
   * @param {string} code corresponding code
   * @param {number} service redirect url after login success
   * @return {Promise} send result
   */
  public quickAuthLoginOnly = (params: {
    service: string;
    mobile: string;
    code: string;
    extra_params?: object;
  }) => {
    let { mobile, code, service, extra_params = {} } = params;
    const data = encryptParams({ mobile, code, service, ...extra_params }, [
      'mobile',
      'code',
    ]);
    return this.request({
      url: WEB_SSO.MOBILE_CODE_LOGIN_ONLY_URL,
      method: 'POST',
      data,
    });
  };

  // /**
  //  * [login by account] out-of-date
  //  * @param {string} account account
  //  * @param {string} password password
  //  */
  // public accountLogin(params: { account: string; password: string }) {
  //   let { account, password, ...extra_params } = params;
  //   const data = encryptParams({ account, password, ...extra_params }, [
  //     'account',
  //     'password',
  //   ]);
  //   return new Promise((resolve, reject) => {
  //     this.request({
  //       url: WEB_SSO.ACCOUNT_LOGIN_URL,
  //       method: 'POST',
  //       data,
  //     })
  //       .then((data: any) => {
  //         resolve(data);
  //       })
  //       .catch((e: any) => {
  //         reject(e);
  //       });
  //   });
  // }

  /**
   * [login by account V2]
   * @param {string} account account
   * @param {number} account_type account type 1: username 2: email 3: phone number
   * @param {string} password password
   * @param {string} service redirect url after successful login
   */
  public accountLoginV2 = (params: {
    account: string;
    account_type?: number;
    password: string;
    service: string;
    extra_params?: object;
  }) => {
    let {
      account,
      password,
      service,
      account_type = 0,
      extra_params = {},
    } = params;
    const data = encryptParams(
      { account, password, account_type, service, ...extra_params },
      ['account', 'password']
    );
    return this.request({
      url: WEB_SSO.ACCOUNT_LOGIN_URL_V2,
      method: 'POST',
      data,
    });
  };

  /**
   * [login by account V2]
   * @param {string} account account
   * @param {number} account_type account type 1: username 2: email 3: phone number
   * @param {string} password password
   * @param {string} service redirect url after successful login
   */
  public accountLoginV3 = (params: {
    account: string;
    account_type?: number;
    password: string;
    service: string;
    extra_params?: object;
  }) => {
    let {
      account,
      password,
      service,
      account_type = 0,
      extra_params = {},
    } = params;
    const data = encryptParams(
      { account, password, account_type, service, ...extra_params },
      ['account', 'password']
    );
    return this.request({
      url: WEB_SSO.ACCOUNT_LOGIN_URL_V3,
      method: 'POST',
      data,
    });
  };

  /**
   * [logout]
   * @param {string} service redirect url after login success
   */
  public logout = (params: { service: string }): void => {
    const { service } = params;
    window.location.href = `${this.host}${WEB_SSO.LOGOUT}?service=${service}`;
  };

  /**
   * [wap login]
   * @param {string} origin request domain, this interface isn't sso
   * @param {string} platform_app_id the thrid appId
   * @param {string} next rederict url
   * @param {string} type default 'sso'
   * @param {string} use_local_host default 1
   * @param {string} scopes default 'user_info'
   * @param {string} url_params
   */
  public wapLogin = (params: {
    origin?: string;
    platform_app_id?: string; // platform_app_id or platform
    platform?: string;
    next: string;
    type?: string;
    use_local_host?: number;
    scopes?: string;
    url_params?: string;
    replace?: boolean;
  }): void => {
    let {
      origin = '',
      type = 'sso',
      use_local_host,
      scopes = 'user_info',
      next,
      url_params = '',
      platform_app_id,
      platform = '',
      replace = false,
    } = params;
    let service = encodeURIComponent(next);
    let realNext = encodeURIComponent(
      this.host + '/auth/login_success/?service=' + service
    );
    const paramMap: any = {
      aid: this.aid,
      type,
      use_local_host: use_local_host,
      scopes,
      next: realNext,
      url_params,
      platform_app_id,
      platform,
    };
    let query: string = '';
    const len = Object.keys(paramMap).length;
    Object.keys(paramMap).forEach((key, index) => {
      if (len === index + 1) {
        query += `${key}=${paramMap[key]}`;
      } else {
        query += `${key}=${paramMap[key]}&`;
      }
    });
    let redirectUrl = `${origin}${WEB_SSO.AUTH_LOGIN_URL}?${query}`;
    // open url in current window
    if (replace) {
      window.location.href = redirectUrl;
    } else {
      // TODO
      let childWindow = window.open(redirectUrl, '_blank');
    }
  };

  /**
   * [send a verification url to email] out-of-date
   * @param {string} email email
   * @param {string} next redirect url after login success
   */
  public sendEmailLink = (params: {
    email: string;
    next: string;
    password?: string;
    extra_params?: object;
  }) => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendEmailLink({
      ...rest,
      ect_type: 13,
      ...extra_params,
    });
  };

  /**
   * [send a verification url to email V2]
   * @param {string} email email
   * @param {string} next redirect url after login success
   */
  public sendEmailLinkV2 = (params: {
    email: string;
    next: string;
    password?: string;
    extra_params?: object;
  }) => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendEmailLinkV2({
      ...rest,
      ect_type: 13,
      ...extra_params,
    });
  };

  /**
   * [send a verification code to email] out-of-date
   * @param {string} email email
   * @param {string} next redirect url after login success
   */
  public sendEmailCode = (params: {
    email: string;
    next: string;
    password?: string;
    email_logic_type?: number;
    extra_params?: object;
  }) => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendEmailCode({
      ...rest,
      ect_type: 13,
      ...extra_params,
    });
  };

  /**
   * [send a verification code to email V2]
   * @param {string} email email
   * @param {string} next redirect url after login success
   */
  public sendEmailCodeV2 = (params: {
    email: string;
    next?: string;
    password?: string;
    email_logic_type?: number;
    extra_params?: object;
  }) => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendEmailCodeV2({
      ...rest,
      ect_type: 13,
      ...extra_params,
    });
  };

  /**
   * [third party login with mobile]
   * @param {string} code authorization code
   * @param {string} profile_key user label
   * @param {number} platform_app_id the thrid appId
   * @param {number} change_bind whether rebind forcely when conflict occurs
   * @param {string} service redirect url after successful login
   */
  public bindWithMobileLogin = (params: {
    code: string;
    platform_app_id: number;
    service: string;
    profile_key?: string;
    change_bind?: number;
    extra_params?: object;
  }) => {
    let {
      code,
      platform_app_id,
      service,
      profile_key,
      change_bind = 0,
      extra_params = {},
    } = params;
    return this.request({
      url: WEB_SSO.BIND_WITH_MOBILE_LOGIN,
      method: 'POST',
      data: {
        code,
        platform_app_id,
        service,
        profile_key,
        change_bind,
        ...extra_params,
      },
    });
  };

  /**
   * [third party login with mobile]
   * @param {string} code authorization code
   * @param {number} platform_app_id the thrid appId
   * @param {string} profile_key user label
   * @param {boolean} login_only - 'true' for only login, 'false' for register and login
   * @param {string} service redirect url after successful login
   */
  public authLogin = (params: {
    code: string;
    platform_app_id: number;
    profile_key?: string;
    service?: string;
    login_only?: boolean;
    extra_params?: object;
  }) => {
    let {
      code,
      platform_app_id,
      service,
      profile_key,
      login_only = false,
      extra_params = {},
    } = params;
    return this.request({
      url: login_only ? WEB_SSO.AUTH_LOGIN_ONLY : WEB_SSO.AUTH_LOGIN,
      method: 'POST',
      data: {
        code,
        platform_app_id,
        service,
        profile_key,
        ...extra_params,
      },
    });
  };

  /**
   * @param {string} mobile - the mobile used to login
   * @param {string} sms_code - the sms captcha
   * @param {string} email - the email used to login
   * @param {string} email_code - the email captcha
   * @param {string} password - corresponding password
   * @param {string} verify_ticket - the ticket returned by server during last verification process
   * @return {Promise} register result
   */
  public mobileEmailRegister = (params: {
    mobile: string;
    sms_code: string;
    email: string;
    email_code: string;
    password: string;
    verify_ticket?: string;
    service?: string;
    extra_params?: object;
  }) => {
    const {
      mobile,
      sms_code,
      email,
      email_code,
      password,
      verify_ticket,
      service,
      extra_params = {},
    } = params;
    const data = encryptParams(
      {
        mobile,
        sms_code,
        email,
        email_code,
        password,
        verify_ticket,
        service,
        sms_type: 16,
        ect_type: 1,
        ...extra_params,
      },
      [
        'mobile',
        'sms_code',
        'sms_type',
        'email',
        'email_code',
        'ect_type',
        'password',
      ]
    );
    return this.request({
      url: WEB_SSO.MOBILE_EMAIL_REGISTER,
      method: 'POST',
      data,
    });
  };

  /**
   * [Industry account user switching SSO]
   * @param {string} Industry account system userIdentityId
   */
  memberSwitch = (params: {
    to_sec_member_id: string;
    extra_params?: object;
  }) => {
    let { to_sec_member_id, extra_params = {} } = params;
    return this.request({
      url: SSO_AFF_URL.MEMBER_SWITCH,
      method: 'POST',
      data: {
        to_sec_member_id,
        ...extra_params,
      },
    });
  };
}
